import { BREAKPOINTS } from '../config';

const mq = window.matchMedia(`(max-width: ${BREAKPOINTS.mqTouch}px)`);
const dragCanvas = document.querySelectorAll('.drag-canvas');

dragCanvas.forEach(container => {
  let activeCanvas = null;
  let activeCursor = null;

  const resetCursor = cursor => {
    if (!cursor) return;
    cursor.classList.remove('is-move');
    cursor.style.transform = '';
  };

  function getCursor(canvas) {
    if (!canvas) return null;
    // Спочатку шукаємо всередині mouse-canvas
    return (
      canvas.querySelector('.mouse-cursor') ||
      // Якщо немає — шукаємо в drag-canvas
      container.querySelector('.mouse-cursor') ||
      null
    );
  }

  function getRect(cursor, canvas) {
    // Якщо курсор всередині canvas — позиція відносно canvas
    if (canvas.contains(cursor)) return canvas.getBoundingClientRect();
    // Якщо курсор в drag-canvas — позиція відносно контейнера
    return container.getBoundingClientRect();
  }

  container.addEventListener('mousemove', e => {
    if (mq.matches) return;

    const canvas = e.target.closest('.mouse-canvas');

    if (canvas !== activeCanvas) {
      resetCursor(activeCursor);
      activeCanvas = canvas;
      activeCursor = getCursor(canvas);

      if (activeCursor) activeCursor.classList.add('is-move');
    }

    if (!activeCursor || !activeCanvas) return;

    const rect = getRect(activeCursor, activeCanvas);
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    activeCursor.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`;
  });

  container.addEventListener('mouseleave', () => {
    resetCursor(activeCursor);
    activeCanvas = null;
    activeCursor = null;
  });
});

mq.addEventListener('change', e => {
  if (!e.matches) return;
  document.querySelectorAll('.mouse-cursor.is-move').forEach(cursor => {
    cursor.classList.remove('is-move');
    cursor.style.transform = '';
  });
});

// <ul class="drag-canvas">
//   <li class="mouse-canvas">
//     <div class="mouse-cursor">
//       <img src="/assets/img/icons/cursor_1.svg" alt="" />
//       <p>text</p>
//     </div>
//   </li>
// </ul>

// <div class="drag-canvas">
//   <ul>
//     <li class="mouse-canvas"></li>
//   </ul>
//   <div class="mouse-cursor">
//     <img src="/assets/img/icons/cursor_1.svg" alt="" />
//     <p>text</p>
//   </div>
// </div>
